<template>
  <SeenOn>
    <p>Trusted by</p>

    <img
      src="~/assets/images/homepage/logos/orange-theory-logo.png"
      alt="OrangeTheory Fitness"
      loading="lazy"
    />

    <img
      src="~/assets/images/homepage/logos/dell-logo.svg"
      alt="Dell"
      loading="lazy"
    />

    <img
      class="participant"
      src="~/assets/images/homepage/logos/small-studio-logo.png"
      alt="Small Studio"
      loading="lazy"
    />

    <img
      src="~/assets/images/homepage/logos/starlight-social-logo.png"
      alt="Starlight Social"
      loading="lazy"
    />

    <img
      src="~/assets/images/homepage/logos/georgetown-logo.png"
      alt="Georgetown University"
      loading="lazy"
    />
  </SeenOn>
</template>

<script>
import SeenOn from '@/components/seen-on';

export default {
  components: {
    SeenOn,
  },
};
</script>

<style lang="scss"></style>
